"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivateEmailLoginConfirmRequestPayloadToJSON = exports.ActivateEmailLoginConfirmRequestPayloadFromJSONTyped = exports.ActivateEmailLoginConfirmRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
function ActivateEmailLoginConfirmRequestPayloadFromJSON(json) {
    return ActivateEmailLoginConfirmRequestPayloadFromJSONTyped(json, false);
}
exports.ActivateEmailLoginConfirmRequestPayloadFromJSON = ActivateEmailLoginConfirmRequestPayloadFromJSON;
function ActivateEmailLoginConfirmRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'customerNo': json['customerNo'],
        'dateOfBirth': (new Date(json['dateOfBirth'])),
        'emailAddress': !(0, runtime_1.exists)(json, 'emailAddress') ? undefined : json['emailAddress'],
        'password': json['password'],
    };
}
exports.ActivateEmailLoginConfirmRequestPayloadFromJSONTyped = ActivateEmailLoginConfirmRequestPayloadFromJSONTyped;
function ActivateEmailLoginConfirmRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'customerNo': value.customerNo,
        'dateOfBirth': (value.dateOfBirth.toISOString().substr(0, 10)),
        'emailAddress': value.emailAddress,
        'password': value.password,
    };
}
exports.ActivateEmailLoginConfirmRequestPayloadToJSON = ActivateEmailLoginConfirmRequestPayloadToJSON;
//# sourceMappingURL=ActivateEmailLoginConfirmRequestPayload.js.map